import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { ImpersonateDialogComponent } from './impersonate-dialog/impersonate-dialog.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { PopupModule } from 'shared/popup-service/popup.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';
import { GdprPrivacyModule } from 'shared/gdpr-privacy/gdpr-privacy.module';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { FormsModule } from '@angular/forms';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { SearchWithAutocompleteModule } from 'shared/search-with-autocomplete/search-with-autocomplete.module';
import { MultiselectAutocompleteModule } from 'shared/multiselect-autocomplete/multiselect-autocomplete.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { CookieDialogComponent } from './cookie-dialog/cookie-dialog.component';

@NgModule({
    declarations: [ProfileComponent, ImpersonateDialogComponent, CookieDialogComponent],
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        MatMenuModule,
        PopupModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        CustomerPrivacyModule,
        GdprPrivacyModule,
        SearchWithAutocompleteModule,
        MultiselectAutocompleteModule,
        MatExpansionModule,
        MatSlideToggleModule,
    ],
    exports: [ProfileComponent, ImpersonateDialogComponent],
})
export class ProfileModule {}
